<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Crear nuevo departamento
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="departmentForm">
        <div class="form-group">
            <label for="departmentFormName" class="form-label">Nombre</label>
            <input type="text" class="form-control" id="departmentFormName" formControlName="name">
        </div>
        <p *ngIf="departmentForm.controls['name'].touched && departmentForm.controls['name'].invalid"
            class="error-message">Este campo es requerido</p>
        <div class="form-group">
            <label for="departmentFormUbication" class="form-label">Ubicación</label>
            <input type="text" class="form-control" id="departmentFormUbication" formControlName="ubication">
        </div>
        <p *ngIf="departmentForm.controls['ubication'].touched && departmentForm.controls['ubication'].invalid"
            class="error-message">Este campo es requerido</p>
        <div class="form-group">
            <label for="departmentFormPhone" class="form-label">Teléfono</label>
            <input type="number" class="form-control" id="departmentFormPhone" formControlName="phone">
        </div>
        <p *ngIf="departmentForm.controls['phone'].touched && departmentForm.controls['phone'].invalid"
            class="error-message">Este campo es requerido</p>
        <div class="form-group">
            <label for="departmentFormDescription" class="form-label">Descripción</label>
            <textarea type="text" class="form-control" id="departmentFormDescription" formControlName="description"
                rows="3"></textarea>
        </div>
        <p *ngIf="departmentForm.controls['description'].touched && departmentForm.controls['description'].invalid"
            class="error-message">Este campo es requerido</p>
    </form>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="departmentForm.invalid || isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>